import { useRef, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import { useCookies } from 'react-cookie';
import { Redirect } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Header from "./bor/header";
import Footer from "./bor/footer";
import Playersmodal from "./bor/playersmodal";
import ArmyModal from "./bor/Armymodal";
import GetServiceNameImagePath from "./bor/GetServiceNameImagePath";
import DistributorProfileModal from "./bor/DistributorProfileModal";
import { WEAPON_META, weaponImageSrc, weaponFxClass, affectingWeaponEntries, renderWeaponArrows, isNaValue, renderElementScene, normalizeWeapons, pastWeaponTypes, pastPointsByType } from "./WeaponFx";
import Topdistributor from "./bor/Topdistributor";
import pointsBGImage from "./../images/Points-box.png"
import pointsBGImageGif from "./../images/score-board-gif.gif"
import cannonBigImage from "./../images/canonbigbottom.png";
import cannonBigGif from "./../images/CanonBig.gif";
import cannonSmallImage from "./../images/cannonsmallbottomnew.png";
import cannonSmallGif from "./../images/canon-catapult-Front-view.gif";
import MatchResult from "./bor/MatchResult";
import { set } from "date-fns";
/// import DistributorProfileModal from "./bor/DistributorProfileModal";


function Bor(props) {
    const divRef = useRef(null);
    const [drawersOpen, setDrawersOpen] = useState(true);
    const handleDrawerClose = () => {
        setDrawersOpen(false); // Close both drawers
        setHideDiv({ "display": "none" });

        setTimeout(() => {
            if (divRef.current) {
                // Scroll to the top of the div
                divRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 500);
    };



    useEffect(() => {

        setTimeout(() => {
            if (divRef.current) {
                // Scroll to the top of the div
                divRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 500);
    }, [])

    let history = useHistory();
    useEffect(() => {
    }, []);

    // Carousal script
    const topCarouselRef = useRef(null);
    const allServicesFilterRef = useRef(null);
    const [allServicesData, setAllServicesData] = useState([]);
    const bottomCarouselRef = useRef(null);
    // const [touchStart, setTouchStart] = useState({ x: 0, scrollLeft: 0 });
    const touchStart = useRef({ x: 0, scrollLeft: 0 }); // Mutable reference to track drag position
    const isDragging = useRef(false); // Mutable reference to track drag state

    const itemSpacing = 20; // Space between carousel items
    const [cookies] = useCookies(['user']);
    const user_id = cookies.user_id;
    const token = cookies.token;
    const points_data = [];
    const my_score = [];
    const [warStartTime, setwarStartTime] = useState(new Date());
    const { state } = props.location;
    const [kdData] = useState(state[0]);
    const [war_id] = useState(state[1]);
    const [error1, setError] = useState(false);
    const [myNormalDistributor, setMyNormalDistributor] = useState({ "astra": 0, "points": 0 });
    const [oppNormalDistributor, setOppNormalDistributor] = useState({ "astra": 0, "points": 0 });
    const [warData, setWarData] = useState({ "status": "success", "war_status": '1', "my_kd_name": "", "my_kd_id": "", "my_a": 0, "my_b": 0, "my_c": 0, "my_total": 0, "my_rm": '', "opp_kd_name": "", "opp_kd_id": "", "opp_a": 0, "opp_b": 0, "opp_c": 0, "opp_total": 0, "opp_rm": '', 'war_end_time': '', 'winner': '' });
    const [myper, setMyper] = useState({ width: "50%" });
    const [oppper, setOppper] = useState({ width: "50%" });
    const [extra, setExtra] = useState('');
    const [myKdText, setMyKdText] = useState('');
    const [myOppText, setMyOppText] = useState('');
    const [lastLink, setLastLink] = useState('');
    const [myBreakup, setMyBreakup] = useState('');
    const [kdBreakup, setKdBreakup] = useState('');
    const [mwBreakup, setMwBreakup] = useState('');
    const timerComponents = [];
    const [points_breakup, setPointsBreakup] = useState('');
    const [my_score_breakup, setMyScoreBreakup] = useState('');
    const [myScore, setMyScore] = useState('');
    const [allPoints, setAllPoints] = useState(null);
    const [hideDiv, setHideDiv] = useState();
    const [isCanonView, setIsCanonView] = useState(false);
    const [canonViewFlag, setCanonViewFlag] = useState(false);
    const [armyViewFlag, setArmyViewFlag] = useState(false);
    const [oppCannonData, setOppCannonData] = useState(null);
    const [myCannonData, setMyCannonData] = useState(null);




    let bgStyleCssObject = {
        backgroundImage: `url(${pointsBGImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100%"
    }
    let [myPointsBGStyle, setMyPointsBGStyle] = useState(bgStyleCssObject);

    let [oppPointsBGStyle, setOppPointsBGStyle] = useState(bgStyleCssObject);
    let userType = localStorage.getItem("user_type");
    const [showSpan, setShowSpan] = useState(true);
    const [showMySpan, setShowMySpan] = useState(true);
    const [showMyNumber, setshowMyNumber] = useState(false);
    const [showMyNumberOp, setshowMyNumberOp] = useState(false);
    const [showOppPoints, setshowOppPoints] = useState("");
    const [showMyPoints, setshowMyPoints] = useState("");


    // Function to snap to the nearest item
    const snapToNearestItem = (carousel, direction) => {
        const items = carousel.querySelectorAll(".carousel-items");
        const itemWidth = items[0].offsetWidth + itemSpacing; // Account for spacing
        const currentScroll = carousel.scrollLeft;
        const currentIndex = Math.round(currentScroll / itemWidth);
        const targetIndex = direction === "left" ? currentIndex - 1 : currentIndex + 1;
        const boundedIndex = Math.max(0, Math.min(targetIndex, items.length - 1));
        const snapScroll = boundedIndex * itemWidth;

        // Scroll the carousel smoothly to the snapped position
        carousel.scrollTo({
            left: snapScroll,
            behavior: "smooth",
        });

        // Sync the other carousel
        const otherCarousel =
            carousel === topCarouselRef.current
                ? bottomCarouselRef.current
                : topCarouselRef.current;

        const scrollRatio = snapScroll / (carousel.scrollWidth - carousel.clientWidth);
        otherCarousel.scrollTo({
            left: scrollRatio * (otherCarousel.scrollWidth - otherCarousel.clientWidth),
            behavior: "smooth",
        });
        if (direction === "right") {
            setIsCanonView(true);
        } else {
            setIsCanonView(false);
        }
    };

    // Start dragging or swiping
    const handleStart = (event, carousel, isTouch = false) => {
        const pageX = isTouch ? event.touches[0].pageX : event.pageX;

        touchStart.current = {
            x: pageX,
            scrollLeft: carousel.scrollLeft,
        };

        if (!isTouch) {
            isDragging.current = true; // Set dragging state for mouse
        }
    };

    // Handle drag or swipe movement
    const handleMove = (event, carousel, isTouch = false) => {
        if (!isDragging.current && !isTouch) return;  // If not dragging or swiping, do nothing

        const pageX = isTouch ? event.touches[0].pageX : event.pageX;
        const delta = touchStart.current.x - pageX;

        carousel.scrollLeft = touchStart.current.scrollLeft + delta;

        // Sync the other carousel
        const otherCarousel =
            carousel === topCarouselRef.current
                ? bottomCarouselRef.current
                : topCarouselRef.current;

        const scrollRatio = carousel.scrollLeft / (carousel.scrollWidth - carousel.clientWidth);
        otherCarousel.scrollLeft = scrollRatio * (otherCarousel.scrollWidth - otherCarousel.clientWidth);

        if (!isTouch) event.preventDefault(); // Prevent text selection on desktop
    };

    // End of drag/swipe
    const handleEnd = (event, carousel, isTouch = false) => {
        const pageX = isTouch ? event.changedTouches[0].pageX : event.pageX;
        const delta = touchStart.current.x - pageX;

        // Reset dragging state for desktop
        if (!isTouch) isDragging.current = false;

        // Snap to the nearest item if the drag/swipe exceeds a threshold
        if (Math.abs(delta) > 50) {
            snapToNearestItem(carousel, delta > 0 ? "right" : "left");
        }
    };

    useEffect(() => {
        const carousels = [topCarouselRef.current, bottomCarouselRef.current];

        // Add event listeners for both carousels (touch and mouse)
        carousels.forEach((carousel) => {
            if (!carousel) return;

            // Touch events for mobile
            carousel.addEventListener("touchstart", (e) => handleStart(e, carousel, true));
            carousel.addEventListener("touchmove", (e) => handleMove(e, carousel, true));
            carousel.addEventListener("touchend", (e) => handleEnd(e, carousel, true));

            // Mouse events for desktop
            carousel.addEventListener("mousedown", (e) => handleStart(e, carousel));
            carousel.addEventListener("mousemove", (e) => handleMove(e, carousel));
            carousel.addEventListener("mouseup", (e) => handleEnd(e, carousel));
            carousel.addEventListener("mouseleave", (e) => handleEnd(e, carousel)); // Handle case when dragging exits the carousel
        });

        // Clean up event listeners when component is unmounted
        return () => {
            carousels.forEach((carousel) => {
                if (!carousel) return;

                // Remove touch events
                carousel.removeEventListener("touchstart", (e) => handleStart(e, carousel, true));
                carousel.removeEventListener("touchmove", (e) => handleMove(e, carousel, true));
                carousel.removeEventListener("touchend", (e) => handleEnd(e, carousel, true));

                // Remove mouse events
                carousel.removeEventListener("mousedown", (e) => handleStart(e, carousel));
                carousel.removeEventListener("mousemove", (e) => handleMove(e, carousel));
                carousel.removeEventListener("mouseup", (e) => handleEnd(e, carousel));
                carousel.removeEventListener("mouseleave", (e) => handleEnd(e, carousel));
            });
        };
    }, []);


    //carousal script


    // points drawer
    const [showBackdrop, setShowBackdrop] = useState(false);
    const [isPointsDrawerOpen, setIsPointsDrawerOpen] = useState(false);
    const [oppIP, setOppIP] = useState({});
    const [oppTop, setOppTop] = useState({});
    const [myIP, setMyIP] = useState({});
    const [myTop, setMyTop] = useState({});
    const [setTimeoutIds, setSetTimeoutIds] = useState([]);
    const [cannonTopBigImage, setCannonTopBigImage] = useState(cannonBigImage);
    const [cannonTopSmallImage, setCannonTopSmallImage] = useState(cannonSmallImage);
    const [cannonBottomBigImage, setCannonBottomBigImage] = useState(cannonBigImage);
    const [cannonBottomSmallImage, setCannonBottomSmallImage] = useState(cannonSmallImage);
    const handlePointsDrawerClick = () => {
        if (userType === 'rm' || userType === 'admins') {
            setIsPointsDrawerOpen(true);
            setShowBackdrop(true);
        }
    };

    const handlePointsDrawerClose = () => {
        setIsPointsDrawerOpen(false);
        setShowBackdrop(false);
    };
    const GetWarData = async () => {
        // console.log("here");
        let kId = kdData.k_id;
        let pointsDiff = 0;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'token': token, 'userId': user_id },
            body: JSON.stringify({ dist_user_id: user_id, k_id: kId, war_id: war_id }),
        };
        // console.log(requestOptions);
        const response = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-war-details', requestOptions);
        var data = await response.json();
        // data = '{"status":"success","war_status":"3","my_kd_name":"AMARAVATHI ROYALS","my_kd_id":201,"my_total":33110,"my_rm":"MARKAPURAM  sales","opp_kd_name":"Magadh Panthers","opp_kd_id":243,"opp_total":53261,"opp_rm":"Ravish Kumar","war_end_time":"2026-05-18 23:59:59","winner":243,"total_points":0,"all_services":["All Rounder","Mobile/DTH Recharge","Utility Bill Payment","AEPS","DMT","IRCTC","Pancard","Membership Rental","Flight Booking","Indo Nepal","MicroATM","Payment Gateway Credit Card","Daily Invest","ppi","Payment Gateway ( Partner Portal )","Bill Payment ( Partner Portal )","Saarthi Bonus","Cash Rotation Bonus","Bonus","Dhanak Device Hub"],"my_pts":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"my_kd_pts":[11716,3170,1667,10762,403,1940,25,0,897,0,650,0,25,3,1402,0,400,50,0,0],"opp_kd_pts":[3311,1523,397,31456,408,0,0,0,0,0,299,0,27,10,0,0,300,1099,14432,0],"is_top_five":[],"my_kd_top":[{"rank":12,"points":444,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/79704615_6_1_20210602124535.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=4a20fdf80a8ebf5bb4f8241365b9a6c4f95d589c9cde9f1d6ca06e5d5b1ccfc3","shopName":"kumar general stores ","name":"VIJAYA LAKSHMI GARA","astra":0,"show_ani":true,"points_added":444},{"rank":1,"points":4035,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/79765499_6_1_20260423125052.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=6f9444cf48cba8e851eb1c873c2eecb01f56dd49b8ea0296755dbdce1fb2aa83","shopName":"KANISHKA Communications ","name":"pothuganti srinivasulu","astra":2,"show_ani":true,"points_added":4035},{"rank":2,"points":2467,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/79851557_6_1_20240816174440.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=1ae6a87f4da608e5c1b4a70f12fe5c24bb437a1209914f770d1c29a3356ee268","shopName":"LUCKY COMMUNICATION AND ONLINE SERVICE","name":"Kandakatla Lvvnm Rao","astra":1,"show_ani":true,"points_added":2467},{"rank":4,"points":1823,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/79873973_6_1_20240606143856.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=a6e2718a5680f2a81f226a584c12fe118e0dc08f4205e850ac0f4e0f04a315fa","shopName":"Manikanta Money Transfer","name":"CHILLARA SIRISHA","astra":0,"show_ani":true,"points_added":1823},{"rank":5,"points":1604,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/79945826_6_1_20250423144242.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=d4afad3628ba26e178772055c75a1133bb4bc0c266a057f19a4a435b827871a6","shopName":"Khushi online services ","name":"Poralla Srinivasa Rao","astra":2,"show_ani":true,"points_added":1604},{"rank":9,"points":1188,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/79986039_6_1_20230213165716.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=c6a224102fedc2d2520a893db0fde1fa375590a410251be3f461332d64c4c7a6","shopName":"P V N P LATHA","name":"VENKATA NAGA PUSHPALATHA POTHUGANTI","astra":1,"show_ani":true,"points_added":1188},{"rank":7,"points":1332,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/80010686_6_1_20260306172028.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=e2d2526ef715b23936d09f0214b52f0273fee3651df67f2e1cd9752717a27ff2","shopName":"Vayunandha and co","name":"pendela anuradha","astra":1,"show_ani":true,"points_added":1332},{"rank":13,"points":373,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/80016685_6_1_20250222183036.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=b67fbaebf01f0eb32021ed92c2d15729f26c642d91728df3652dbe6d5c240449","shopName":"YASIN COMMUNICATIONS","name":"yasin shaik","astra":1,"show_ani":true,"points_added":373},{"rank":8,"points":1193,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/80173589_6_1_20220907192330.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=0963de0e69b6c6d881b184ca58ba0db21ee67c6a44ddbc4a115f804f453a86f2","shopName":"BHASKAR TRAVELS","name":"EMMADI BALA BHASKAR","astra":2,"show_ani":true,"points_added":1193},{"rank":3,"points":2201,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/80177160_6_1_20240708123710.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=d1bb89ebad5c5df96f0c7413d26cc0b6b4c74c3a47ba269d282250de2494a551","shopName":"Raghuram Communication","name":"RAGHU RAM SAKHAMURI","astra":1,"show_ani":true,"points_added":2201},{"rank":14,"points":358,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/80202068_6_1_20230317135253.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=55a2d5500ab93b9ef7f241ad1b622836473e510450371683112104ab5e5e39f4","shopName":"BHARATHI COMMUNICATIONS","name":"mandadapu venkata prasanna chowda harish kumar","astra":1,"show_ani":true,"points_added":358},{"rank":6,"points":1406,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/80217126_6_1_20231003123838.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=632fd865ccfd11c6f9fc88c5271391c9f6f946e4056e8a553bd6ad4ea311678b","shopName":"Sai balaji Enterprises","name":"MADIRA JAYAVARDHAN REDDY","astra":0,"show_ani":true,"points_added":1406},{"rank":11,"points":470,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/80233905_6_1_20240307163111.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=0640c2e921dc99671a0bddd8c2864406d6d477dc595c6c8b2f288730e47a2f69","shopName":"GOWTHAM ONLINE SERVICES","name":"sai krishna chintala","astra":1,"show_ani":true,"points_added":470},{"rank":10,"points":472,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/80248794_6_1_20250604120026.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=a4c5519639036de156ed391d7c6473e222078a06902b762cd3c91ab2c1a80d32","shopName":"Yesu prabhu fancy store","name":"muralikrishna kore","astra":0,"show_ani":true,"points_added":472},{"rank":15,"points":330,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/80289152_6_1_20260512135705.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=dc962f12e1e1cbe1d38e767cd35c9c67a252515b8883405151216e8707c77f10","shopName":"AMEER TRAVELS AND ONLINE SERVICES","name":"abubakar siddiq shaik","astra":0,"show_ani":true,"points_added":330}],"opp_kd_top":[{"rank":11,"points":1564,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/79774083_6_1_20200526174428.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=f68a48dae5bb52229d19c74ff9ba4686c92ebeb045d6c07f5a1b18460e9648dc","shopName":"S.s.k.Electronic","name":"SHIVSHANKAR  KUMAR","astra":2,"show_ani":true,"points_added":1564},{"rank":12,"points":1343,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/79833556_6_1_20240803133049.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=0e787eb88be40b1c5b5390d81378b2c1ded1871f470c2e072f77d6aed06096a4","shopName":"Bharat Enterprises","name":"md ehsan","astra":0,"show_ani":true,"points_added":1343},{"rank":5,"points":2643,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/80165408_6_1_20250507141429.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113011Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=30b5053e8293e788b1044e9c61fd34b441eecdc18047b65ed5b9d471291a6742","shopName":"Vikash internet ","name":"anant kumar","astra":3,"show_ani":true,"points_added":2643},{"rank":9,"points":1955,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/80214166_6_1_20250601132428.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=596c835e03e67219e251e3cf66ef2cc26078cded6ae1333d56d74f066e3d969f","shopName":"Ritik online ","name":"rajesh kumar","astra":0,"show_ani":true,"points_added":1955},{"rank":8,"points":2186,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/80215537_6_1_20230911165532.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=6ed333e74100bd37f6f6c2605450307315b506f7692579b46cef3252e39cb200","shopName":"Aman Grahak seva kendra smart","name":"aman kumar","astra":3,"show_ani":true,"points_added":2186},{"rank":1,"points":6042,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/80215809_6_1_20230916140733.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113011Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=27c5d507e13cb73eec5b179863859d387952741a52e2026dbb2ca99e3b6218e4","shopName":"himanshu singar Mahal Birnawan","name":"SHUNIL RAJAK","astra":3,"show_ani":true,"points_added":6042},{"rank":4,"points":4027,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/80216034_6_1_20230918124159.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113011Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=7345cc9e28513e94f144ebd1db30a5c886af4fd617ce0cb62ac9cd2ff2a92590","shopName":"Varsha digital service ","name":"uma shankar prasad","astra":3,"show_ani":true,"points_added":4027},{"rank":10,"points":1860,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/80216147_6_1_20230920113714.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=1a8e7890f9e5af38179556aade08bfc9942980065d567ae478d019c4b8445268","shopName":"FATEHPUR TELECOM","name":"asha kumari","astra":1,"show_ani":true,"points_added":1860},{"rank":14,"points":1087,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/80218407_6_1_20231019102219.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=e4d9bdbe67985083dcd52c660e45863e1d4ec03caae4b891fe50ddc7a54f63c4","shopName":"BHARAT SHARMA","name":"bharat sharma","astra":1,"show_ani":true,"points_added":1087},{"rank":2,"points":5490,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/80251267_6_1_20240808133018.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113011Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=5afe227917ac1e21c97d07adf338ae22228dfa9475e2df387bd4c3180da21e83","shopName":"M seva kendra ","name":"OKIL CHAUDHARY","astra":3,"show_ani":true,"points_added":5490},{"rank":15,"points":983,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/80272614_6_1_20250214173427.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=842135e75c3deeb40bb4b7a77e2654b91a61833def9d2ac09473f741dfc5d72a","shopName":"Subhkamana cebal network ","name":"dinanath kumar sinha","astra":1,"show_ani":true,"points_added":983},{"rank":7,"points":2221,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/80292572_6_1_20260323104232.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=6f746503964436fa3a27066d1941fe648e7b7f46077a5dcbde409373bbb3fa6a","shopName":"VK enterprises ","name":"vimal kumar","astra":2,"show_ani":true,"points_added":2221},{"rank":13,"points":1234,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/80320147_6_1_20251016125020.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=7d741fc595d465e087f2941aaeaf0709ec68140e742856bd904265694f1f7334","shopName":"Maa online ","name":"KAMLESH KUMAR","astra":3,"show_ani":true,"points_added":1234},{"rank":6,"points":2263,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/80338082_6_1_20260121140703.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113012Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1799&X-Amz-Signature=4506da042a0d995e39e3c5b9c6a4127ebc4bcab0e0d0c0066adae34af716e3b7","shopName":"Maa Kamla Enterprises ","name":"dinesh kumar","astra":3,"show_ani":true,"points_added":2263},{"rank":3,"points":4973,"profile_pic":"https://pay1dmslive.s3.ap-south-1.amazonaws.com/80340193_6_1_20260205140033.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATHYMMYBXKQBDJVTW%2F20260907%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260907T113011Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=ba72baddb3d0a33928c3d5da04dac9e4f07b38c43c1e1784f4ae0174125911a3","shopName":"Kailash Cyber Cafe ","name":"sarita kumari","astra":3,"show_ani":true,"points_added":4973}],"my_kd_ip":[],"opp_kd_ip":[],"my_kd_brahmastra":0,"opp_kd_brahmastra":8,"show_brahmastra_ani":true,"my_brahmastra_added":0,"opp_brahmastra_added":8,"my_pts_added":33110,"opp_pts_added":53261,"my_brahmastra_added_rm":0,"opp_brahmastra_added_rm":8,"show_brahmastra_ani_rm":true,"rm_time":"17 Hr 9 Min","per_total":0}';
        // console.log(data, "war details1");
        // data = JSON.parse(data);
        // TEMP: get-war-details does not return `weapons` yet - remove once backend ships it
        // if (!data.weapons) {
        //     data.weapons = {
        //         my: { active: [{start : "2026-09-09 18:00:00" , end : "2026-09-09 18:03:00"  , boost : '26%' , type : "fire"}], past: { water: 20, land: 30 }, upcomming:{start : "2026-09-09 18:00:00" , end : "2026-09-09 18:03:00"  , boost : '26%' , type : "fire"} },
        //         opp: { active: [{start : "na" , end : "na"  , boost : 'na' , type : "fire"}], past: { air: 20 , land: 25} }
        //     };
        // }
        if (data.status !== "success") {
            setError(true);
        }
        if (!(data.my_total == 0 && data.opp_total == 0)) {
            setMyper({ width: (data.my_total * 100 / (data.opp_total + data.my_total)) + "%" });
            setOppper({ width: 100 - (data.my_total * 100 / (data.opp_total + data.my_total)) + "%" });
        }
        pointsDiff = data.my_total - data.opp_total;
        if (pointsDiff < 0) {
            setAllPoints(`Your region trail by ${Math.abs(pointsDiff)}`);
        } else {
            setAllPoints(`Your region is ${pointsDiff} ahead.`);
        }
        // //hard code for testing
        // data.show_brahmastra_ani = true;
        // data.show_brahmastra_ani_rm = true;
        //  data.is_top_five.profile_pic = "";
        //  data.is_top_five = {"rank": 1,"points": 34625.4,"profile_pic": "https://pay1dms.s3.amazonaws.com/40649947_6_1_20220427125351.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAI7HSXGL4VHBWFAMQ%2F20250106%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20250106T064816Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=bf4039d4acfbdeb177221eb938bd387268b53e48608f6b097c3bf438ab5c4786","shopName": "Dhanak shop Pay1","name": "tester rockyeye","astra": "0","show_ani": true}
        //  data.is_top_five = {}
        // //hard code for testing end

        // normal distributor
        let my_kd_ip_point_total = data.my_kd_ip.reduce((acc, currentValue) => acc + currentValue.points, 0);
        let my_kd_top_point_total = data.my_kd_top.reduce((acc, currentValue) => acc + currentValue.points, 0);

        let my_kd_ip_astra_total = data.my_kd_ip.reduce((acc, currentValue) => {
            if (Number(currentValue.astra) >= 3) {
                return acc + Number(currentValue.astra) / 3;
            }
            return acc;
        }, 0);
        let my_kd_top_astra_total = data.my_kd_top.reduce((acc, currentValue) => {
            if (Number(currentValue.astra) >= 3) {
                return acc + Number(currentValue.astra) / 3;
            }
            return acc;
        }, 0);
        let myNormalDistributorData = {
            "astra": data.my_kd_brahmastra - (my_kd_ip_astra_total + my_kd_top_astra_total),
            "points": data.my_total - (my_kd_ip_point_total + my_kd_top_point_total)
        }
        console.log('normal dist')
        console.log(myNormalDistributorData);

        let opp_kd_ip_point_total = data.opp_kd_ip.reduce((acc, currentValue) => acc + currentValue.points, 0);
        let opp_kd_top_point_total = data.opp_kd_top.reduce((acc, currentValue) => acc + currentValue.points, 0);

        let opp_kd_ip_astra_total = data.opp_kd_ip.reduce((acc, currentValue) => {
            if (Number(currentValue.astra) >= 3) {
                return acc + Number(currentValue.astra);
            }
            return acc;
        }, 0);
        let opp_kd_top_astra_total = data.opp_kd_top.reduce((acc, currentValue) => {
            if (Number(currentValue.astra) >= 3) {
                return acc + Number(currentValue.astra);
            }
            return acc;
        }, 0);
        let oppNormalDistributorData = {
            "astra": data.opp_kd_brahmastra - (opp_kd_ip_astra_total + opp_kd_top_astra_total),
            "points": data.opp_total - (opp_kd_ip_point_total + opp_kd_top_point_total)
        }
        console.log('normal  opp dist')
        console.log(oppNormalDistributorData);

        setMyNormalDistributor((prevState) => (
            {
                ...prevState,
                "astra": data.my_kd_brahmastra - (my_kd_ip_astra_total + my_kd_top_astra_total),
                "points": data.my_total - (my_kd_ip_point_total + my_kd_top_point_total)
            }
        ));
        setOppNormalDistributor((prevState) => (
            {
                ...prevState,
                "astra": data.opp_kd_brahmastra - (opp_kd_ip_astra_total + opp_kd_top_astra_total),
                "points": data.opp_total - (opp_kd_ip_point_total + opp_kd_top_point_total)
            }
        ));

        // cannon data logic
        // Create the JSON object
        setCannonNames(data);
        // normal distributor end
        setCanonViewFlag(true);
        setArmyViewFlag(true);
        setPointsBreakup(points_data);
        setMyScoreBreakup(my_score);
        data.k_id = kId;
        let waf = data.war_end_time;
        const warStartTime = new Date(waf);
        localStorage.setItem("wet", warStartTime);

        // data.war_status = 3;
        setwarStartTime(warStartTime);
        setWarData(data);
        let userType = localStorage.getItem("user_type");
        setMyOppText(data.opp_kd_name);
        if (userType === 'rm' || userType === 'admins') {
            setMyKdText(data.my_kd_name);
            setExtra(<div className="row mb-3" >
                <div className="w-100 profile-flt-l">
                </div>
            </div>);
            setLastLink(
                <div className="row mb-3">
                    <div className="profile-war-info-my-pts-btn w-100 px-3">
                        <div className="profile-war-header-2 w-100" data-toggle="modal" data-target="#bottom_modal_3">
                            <Link to={{
                                pathname: "/war-score-details",
                                state: [data, war_id]
                            }} className="w-100 profile-flt-l">

                                <div style={{ color: "white" }} >Distributor Details</div>
                            </Link>
                        </div>
                    </div>
                </div>
            );
        } else {
            {/*
			setMyScore(<div className="profile-war-data-bottom w-100 profile-flt-l center">
				<div className="ms-button" data-toggle="modal" data-target="#bottom_modal" >My Score</div>
			</div>);
			*/}
            setLastLink(
                <div className="row mb-3">
                    <div className="profile-war-info-my-pts-btn w-100 px-3">
                        <div className="profile-war-header-2 w-100" data-toggle="modal" data-target="#bottom_modal_3">
                            <div className="w-100 profile-flt-l">My Points</div>
                        </div>
                    </div>
                </div>
            );
            setMyKdText("Your Region");
        }
        setMyScore(<div className="profile-war-data-bottom w-100 profile-flt-l center">
            <div className="ms-button-2" data-toggle="modal" data-target="#bottom_modal_2" >Region Details</div>
        </div>);

        const myB = [];
        const kdB = [];
        const mwB = [];
        var i = 0
        // data.my_pts = data.my_pts.sort((a, b) => b - a);
        const myServicesAndPoints = data.all_services.reduce((acc, service, index) => {
            acc[service] = data.my_pts[index];
            return acc;
        }, {});
        let sortedMyServicesAndPoints = Object.fromEntries(
            Object.entries(myServicesAndPoints).sort(([, value1], [, value2]) => value2 - value1) // desc order
        );
        Object.keys(sortedMyServicesAndPoints).forEach(function (serviceName) {
            let serviceKey = data.all_services.indexOf(serviceName);
            let imgName = GetServiceNameImagePath(data.all_services[serviceKey])
            let img = require("./../images/" + imgName).default;
            const excludeServices = ["All Rounder"];
            if (!excludeServices.includes(data.all_services[serviceKey])) {
            // if (data.all_services[serviceKey] !== "All Rounder") {
                if (serviceName === 'Utility Bill Payment') {
                    serviceName = 'Bill Payment'
                } else if (serviceName === 'Daily Invest') {
                    serviceName = 'Daily Reserve'
                } else if (serviceName === 'Payment Gateway Credit Card') {
                serviceName = 'Payments';

                } else if (serviceName === 'Payment Gateway ( Partner Portal )') {
                    serviceName = 'Partner Portal';
                }

                if(serviceName === 'Saarthi Bonus' && !data.my_pts[serviceKey]>0){
                    return;
                }
                myB.push(
                    <div className="servicebox1dist" key={"myB_" + i}>
                        <div className="servicebox-innerdist">
                            <div className="servicename mt-1">
                                <img src={img} className="img-fluid img-service" alt="irctc" />
                                <span className="s1 s1sm">{serviceName}</span>
                            </div>
                            <div className="servicepoints d-flex align-items-center mt-1">
                                <img src="../images/BOR/points-coins.png" className="img-fluid img-service-point"
                                    alt="point" />
                                <span className="sp1">{data.my_pts[serviceKey]}</span>
                            </div>
                        </div>
                    </div>
                );
                i++;
            }
        });

        kdB.push(getRegionDetails(data));
        kdB.push(getWeaponDetails(data));
        mwB.push(getMatchDetails(data));
        setMyBreakup(myB);
        setKdBreakup(kdB);
        setMwBreakup(mwB);

        localStorage.setItem("ws", 0);
        if (String(data.war_status) === '1') {
            localStorage.setItem("ws", 1);
        }
    }

    const getRegionDetails = (data) => {
        let kdB = [];
        let j = 0;
        const myServicesAndPoints = data.all_services.reduce((acc, service, index) => {
            acc[service] = data.my_kd_pts[index];
            return acc;
        }, {});
        let sortedMyServicesAndPoints = Object.fromEntries(
            Object.entries(myServicesAndPoints).sort(([, value1], [, value2]) => value2 - value1) // desc order
        );
        Object.keys(sortedMyServicesAndPoints).forEach((serviceName) => {
            let serviceKey = data.all_services.indexOf(serviceName);
            let imgName = GetServiceNameImagePath(data.all_services[serviceKey])
            let img = require("./../images/" + imgName).default;
            // console.log("serviceName", serviceName, "index of ", data.all_services.indexOf(serviceName))
            let t1 = data.my_kd_pts[serviceKey];
            let t2 = data.opp_kd_pts[serviceKey];
            let tp1 = `50%`;
            let tp2 = `50%`;
            if (t1 !== 0 && t2 === 0) {
                tp1 = `100%`;
                tp2 = `0%`;
            } else if (t1 === 0 && t2 !== 0) {
                tp1 = `0%`;
                tp2 = `100%`;
            } else if (t1 !== 0 && t2 !== 0) {
                let tp = (t1 / (t1 + t2)) * 100;
                tp1 = tp + `%`;
                tp2 = (100 - tp) + `%`;
            }

            let serviceNameRt = data.all_services[serviceKey];

            if (serviceNameRt === 'Utility Bill Payment') {
                serviceNameRt = 'Bill Payment'
            } else if (serviceNameRt === 'Daily Invest') {
                serviceNameRt = 'Daily Reserve'
            } else if (serviceNameRt === 'Payment Gateway Credit Card') {
                serviceNameRt = 'Payments';

            } else if (serviceNameRt === 'Payment Gateway ( Partner Portal )') {
                serviceNameRt = 'Partner Portal';
            }
            kdB.push(
                <div className="regiondetailsboxdist" key={"oppB_" + j}>
                    <div className="heading-box pt-1 pb-1">
                        <img src={img} className="img-fluid" />
                        <p className="">{serviceNameRt}</p>
                    </div>
                    <div className="progress-wrapper">
                        <div className="progress-container">
                            <div className="progress-bar" style={{ "width": tp1 }} id="progress-bar"></div>
                        </div>
                        <div className="progress-text">
                            <span id="progress-value">{data.my_kd_pts[serviceKey]}</span>
                            <span>{data.opp_kd_pts[serviceKey]}</span>
                        </div>
                    </div>
                </div>
            );
            j++;
        });

        return kdB;
    }

    const formatBoostTime = (raw) => {
        const m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(raw || "");
        if (!m) {
            return raw || "";
        }
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let hour = parseInt(m[4], 10);
        const ampm = hour >= 12 ? "PM" : "AM";
        hour = hour % 12 || 12;
        return parseInt(m[3], 10) + " " + months[parseInt(m[2], 10) - 1] + ", " + hour + ":" + m[5] + " " + ampm;
    };

    const formatBoostClock = (raw) => {
        const m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(raw || "");
        if (!m) {
            return raw || "";
        }
        let hour = parseInt(m[4], 10);
        const ampm = hour >= 12 ? "PM" : "AM";
        hour = hour % 12 || 12;
        return hour + ":" + m[5] + " " + ampm;
    };

    // "9 Sep, 6:00 PM - 6:03 PM" (date shown once), or just the start if no end
    const formatBoostRange = (start, end) => {
        if (isNaValue(start)) {
            return "";
        }
        const from = formatBoostTime(start);
        return isNaValue(end) ? from : from + " - " + formatBoostClock(end);
    };

    const renderUpcomingBoost = () => {
        const up = normalizeWeapons(warData).my?.upcomming;
        if (!up || !up.type) {
            return null;
        }
        const meta = WEAPON_META[up.type];
        const label = meta ? meta.label : up.type;
        if (meta?.negative) {
            return (
                <div className="weapon-boost-note">
                    Your kingdom has fired <span className="weapon-boost-hl">{label}</span> weapon
                    on the opponent kingdom
                </div>
            );
        }
        return (
            <div className="weapon-boost-note">
                Your kingdom has fired <span className="weapon-boost-hl">{label}</span> weapon
                and you have an upcoming boost of <span className="weapon-boost-hl">{up.boost}</span>
                {isNaValue(up.start) ? null : <> at <span className="weapon-boost-hl">{formatBoostRange(up.start, up.end)}</span></>}
            </div>
        );
    };

    // a side shows its own boosts plus negative weapons the other side fired at it
    const renderArmyWeaponBg = (side) => {
        const weapons = normalizeWeapons(warData);
        const entries = affectingWeaponEntries(weapons[side], weapons[side === "my" ? "opp" : "my"]);
        if (entries.length === 0) {
            return null;
        }
        return (
            <>
                <div className={"weapon-army-bg weapon-army-bg-side-" + side + " weapon-army-bg-" + WEAPON_META[entries[0].type].base}>
                    {entries.map((entry, i) => (
                        <div className={"weapon-army-bg-cell " + weaponFxClass(entry.type)} key={side + "-armybg-" + i}>
                            {renderElementScene(entry.type)}
                            {renderWeaponArrows(WEAPON_META[entry.type].negative, 10)}
                        </div>
                    ))}
                </div>
                {/* kept outside the scene layer so it is never mirrored by its rotateY flip */}
                <div className={"weapon-army-badges weapon-army-badges-" + side}>
                    {entries.map((entry, i) => {
                        const meta = WEAPON_META[entry.type];
                        // negative weapons show only the icon - no boost or time window
                        const hasWindow = !meta.negative && !isNaValue(entry.start) && !isNaValue(entry.end);
                        return (
                            <div className={"weapon-army-badge " + (meta.negative ? "weapon-chip-negative" : "weapon-chip-positive")} key={side + "-armybadge-" + i}>
                                <img src={weaponImageSrc(meta.image)} alt={meta.label} />
                                {hasWindow ? (
                                    <span className="weapon-army-badge-info">
                                        {isNaValue(entry.boost) ? null : <b>{entry.boost}</b>}
                                        <span>{formatBoostRange(entry.start, entry.end)}</span>
                                    </span>
                                ) : null}
                            </div>
                        );
                    })}
                </div>
            </>
        );
    };

    const getWeaponDetails = (data) => {
        const { my, opp } = normalizeWeapons(data);
        const types = pastWeaponTypes(my, opp);
        if (types.length === 0) {
            return [];
        }
        // points summed per type - a weapon can be fired more than once
        const myPast = pastPointsByType(my);
        const oppPast = pastPointsByType(opp);
        // biggest contributor first, same ordering idea as the service rows
        types.sort((a, b) => ((oppPast[b] || 0) + (myPast[b] || 0)) - ((oppPast[a] || 0) + (myPast[a] || 0)));

        let wB = [];
        wB.push(
            <div className="regiondetails-weapons-title" key="weapons_title">Weapons</div>
        );
        types.forEach((type, j) => {
            const meta = WEAPON_META[type];
            const t1 = myPast[type] || 0;
            const t2 = oppPast[type] || 0;
            let tp1 = `50%`;
            if (t1 !== 0 && t2 === 0) {
                tp1 = `100%`;
            } else if (t1 === 0 && t2 !== 0) {
                tp1 = `0%`;
            } else if (t1 !== 0 && t2 !== 0) {
                tp1 = ((t1 / (t1 + t2)) * 100) + `%`;
            }
            wB.push(
                <div className="regiondetailsboxdist" key={"weaponB_" + j}>
                    <div className="heading-box pt-1 pb-1">
                        <img src={weaponImageSrc(meta.image)} className={"img-fluid weapon-detail-icon " + (meta.negative ? "weapon-chip-negative" : "weapon-chip-positive")} alt={meta.label} />
                        <p className="">{meta.label}</p>
                    </div>
                    <div className="progress-wrapper">
                        <div className="progress-container">
                            <div className="progress-bar" style={{ "width": tp1 }}></div>
                        </div>
                        <div className="progress-text">
                            <span>{t1}</span>
                            <span>{t2}</span>
                        </div>
                    </div>
                </div>
            );
        });
        return wB;
    }

    const ProgressBar = ({ initialValue, finalValue, myPoints, oppPoints }) => {
        const [width, setWidth] = useState(`50%`); // Start at 50%

        useEffect(() => {
            // Start animation after a small delay
            const timer = setTimeout(() => {
                setWidth(`${finalValue}%`);
            }, 4000);

            return () => clearTimeout(timer);
        }, [finalValue]);

        return (
            <div className="progress-wrapper">
                <div className="progress-container">
                    <div
                        className="progress-bar"
                        style={{
                            "width": width,
                            "transition": "width 3s ease-in-out" // Add smooth transition
                        }}
                        id="progress-bar"
                    ></div>
                </div>
                <div className="progress-text">
                    <span id="progress-value">{myPoints}</span>
                    <span>{oppPoints}</span>
                </div>
            </div>
        );
    };

    const getMatchDetails = (data) => {
        let mwB = [];
        let j = 0;
        const myServicesAndPoints = data.all_services.reduce((acc, service, index) => {
            acc[service] = data.my_kd_pts[index];
            return acc;
        }, {});
        let sortedMyServicesAndPoints = Object.fromEntries(
            Object.entries(myServicesAndPoints).sort(([, value1], [, value2]) => value2 - value1) // desc order
        );
        Object.keys(sortedMyServicesAndPoints).forEach((serviceName) => {
            let serviceKey = data.all_services.indexOf(serviceName);
            let imgName = GetServiceNameImagePath(data.all_services[serviceKey])
            let img = require("./../images/" + imgName).default;
            // console.log("serviceName", serviceName, "index of ", data.all_services.indexOf(serviceName))
            let t1 = data.my_kd_pts[serviceKey];
            let t2 = data.opp_kd_pts[serviceKey];
            let tp1 = `50%`;
            let tp2 = `50%`;

            const myTotal = data.my_kd_pts.reduce((sum, x) => sum + x, 0);
            const oppTotal = data.opp_kd_pts.reduce((sum, x) => sum + x, 0);
            const isMatchTie = myTotal === oppTotal;
            const isMyWinner = myTotal > oppTotal;
            // decide left/right based on match winner
            const leftPts = isMatchTie ? t1 : (isMyWinner ? t1 : t2);
            const rightPts = isMatchTie ? t2 : (isMyWinner ? t2 : t1);
            // if (t1 !== 0 && t2 === 0) {
            //     tp1 = `100%`;
            //     tp2 = `0%`;
            // } else if (t1 === 0 && t2 !== 0) {
            //     tp1 = `0%`;
            //     tp2 = `100%`;
            // } else if (t1 !== 0 && t2 !== 0) {
            //     let tp = (t1 / (t1 + t2)) * 100;
            //     tp1 = tp + `%`;
            //     tp2 = (100 - tp) + `%`;
            // }
            // compute fill percentage from leftPts share
            const total = leftPts + rightPts;
            const finalPercentage = total === 0
                ? 50
                : (leftPts / total) * 100;
            // if (t1 !== 0 && t2 === 0) {
            //     finalPercentage = 100;
            // } else if (t1 === 0 && t2 !== 0) {
            //     finalPercentage = 0;
            // } else if (t1 !== 0 && t2 !== 0) {
            //     finalPercentage = (t1 / (t1 + t2)) * 100;
            // }

            let serviceNameRt = data.all_services[serviceKey];

            if (serviceNameRt === 'Utility Bill Payment') {
                serviceNameRt = 'Bill Payment'
            } else if (serviceNameRt === 'Daily Invest') {
                serviceNameRt = 'Daily Reserve'
            }
            mwB.push(
                <div className="regiondetailsboxdist" key={"oppB_" + j}>
                    <div className="heading-box pt-1 pb-1">
                        <img src={img} className="img-fluid" />
                        <p className="">{serviceNameRt}</p>
                    </div>
                    <ProgressBar
                        initialValue={50}
                        finalValue={finalPercentage}
                        myPoints={leftPts}
                        oppPoints={rightPts}
                    />
                </div>
            );
            j++;
        });

        return mwB;
    }

    const setCannonNames = (data) => {
        const excludeServices = ["All Rounder", "Bonus", "Dhanak Refurb", "Payment Gateway Credit Card"];
        const myServicePoints = data.all_services.reduce((acc, service, index) => {
            if (!excludeServices.includes(service)) {
                acc[service] = data.my_kd_pts[index];
            }
            return acc;
        }, {});

        const oppServicePoints = data.all_services.reduce((acc, service, index) => {
            if (!excludeServices.includes(service)) {
                acc[service] = data.opp_kd_pts[index];
            }
            return acc;
        }, {});
        let sortedMyServicePoints = Object.fromEntries(
            Object.entries(myServicePoints).sort(([, valueA], [, valueB]) => valueA - valueB)
        );
        let sortedOppServicePoints = Object.fromEntries(
            Object.entries(oppServicePoints).sort(([, value1], [, value2]) => value1 - value2) // Ascending order
        );
        setMyCannonData(Object.keys(sortedMyServicePoints));
        setOppCannonData(Object.keys(sortedOppServicePoints));
    }
    const GetWarDataSecond = async () => {
        // console.log("here");
        let kId = kdData.k_id;
        let pointsDiff = 0;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'token': token, 'userId': user_id },
            body: JSON.stringify({ dist_user_id: user_id, k_id: kId, war_id: war_id }),
        };
        // console.log(requestOptions);
        const response = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-war-details', requestOptions);
        const data = await response.json();
        console.log(data);
        // TEMP: get-war-details does not return `weapons` yet - remove once backend ships it
        if (!data.weapons) {
            data.weapons = {
                my: { active: ["fire"], past: { water: 20, land: 30 }, upcomming: { start: "2026-09-09 18:00:00", boost: '26%', type: "fire" } },
                opp: { active: ["fire"], past: { air: 20, land: 25 } }
            };
        }
        if (data.status !== "success") {
            setError(true);
        }
        if (!(data.my_total == 0 && data.opp_total == 0)) {
            setMyper({ width: (data.my_total * 100 / (data.opp_total + data.my_total)) + "%" });
            setOppper({ width: 100 - (data.my_total * 100 / (data.opp_total + data.my_total)) + "%" });
        }
        pointsDiff = data.my_total - data.opp_total;
        if (pointsDiff < 0) {
            setAllPoints(`Your region trail by ${Math.abs(pointsDiff)}`);
        } else {
            setAllPoints(`Your region is ${pointsDiff} ahead.`);
        }
        //hard code for testing

        // data.show_brahmastra_ani = true;
        // data.show_brahmastra_ani_rm = true;
        // data.is_top_five.profile_pic = "";
        // data.is_top_five = {"rank": 1,"points": 34625.4,"profile_pic": "https://pay1dms.s3.amazonaws.com/40649947_6_1_20220427125351.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAI7HSXGL4VHBWFAMQ%2F20250106%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20250106T064816Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=bf4039d4acfbdeb177221eb938bd387268b53e48608f6b097c3bf438ab5c4786","shopName": "Dhanak shop Pay1","name": "tester rockyeye","astra": "0","show_ani": true}
        // data.is_top_five = {}

        //hard code for testing end

        // normal distributor
        let my_kd_ip_point_total = data.my_kd_ip.reduce((acc, currentValue) => acc + currentValue.points, 0);
        let my_kd_top_point_total = data.my_kd_top.reduce((acc, currentValue) => acc + currentValue.points, 0);

        let my_kd_ip_astra_total = data.my_kd_ip.reduce((acc, currentValue) => {
            if (Number(currentValue.astra) === 3) {
                return acc + Number(currentValue.astra) / 3;
            }
            return acc;
        }, 0);
        let my_kd_top_astra_total = data.my_kd_top.reduce((acc, currentValue) => {
            if (Number(currentValue.astra) === 3) {
                return acc + Number(currentValue.astra) / 3;
            }
            return acc;
        }, 0);
        let myNormalDistributorData = {
            "astra": data.my_kd_brahmastra - (my_kd_ip_astra_total + my_kd_top_astra_total),
            "points": data.my_total - (my_kd_ip_point_total + my_kd_top_point_total)
        }
        console.log('normal dist')
        console.log(myNormalDistributorData);

        let opp_kd_ip_point_total = data.opp_kd_ip.reduce((acc, currentValue) => acc + currentValue.points, 0);
        let opp_kd_top_point_total = data.opp_kd_top.reduce((acc, currentValue) => acc + currentValue.points, 0);

        let opp_kd_ip_astra_total = data.opp_kd_ip.reduce((acc, currentValue) => {
            if (Number(currentValue.astra) >= 3) {
                return acc + Number(currentValue.astra);
            }
            return acc;
        }, 0);
        let opp_kd_top_astra_total = data.opp_kd_top.reduce((acc, currentValue) => {
            if (Number(currentValue.astra) >= 3) {
                return acc + Number(currentValue.astra);
            }
            return acc;
        }, 0);
        let oppNormalDistributorData = {
            "astra": data.opp_kd_brahmastra - (opp_kd_ip_astra_total + opp_kd_top_astra_total),
            "points": data.opp_total - (opp_kd_ip_point_total + opp_kd_top_point_total)
        }
        console.log('normal  opp dist')
        console.log(oppNormalDistributorData);

        setMyNormalDistributor((prevState) => (
            {
                ...prevState,
                "astra": data.my_kd_brahmastra - (my_kd_ip_astra_total + my_kd_top_astra_total),
                "points": data.my_total - (my_kd_ip_point_total + my_kd_top_point_total)
            }
        ));
        setOppNormalDistributor((prevState) => (
            {
                ...prevState,
                "astra": data.opp_kd_brahmastra - (opp_kd_ip_astra_total + opp_kd_top_astra_total),
                "points": data.opp_total - (opp_kd_ip_point_total + opp_kd_top_point_total)
            }
        ));

        // Create the JSON object
        setCannonNames(data);


        // normal distributor end
        setCanonViewFlag(true);
        setArmyViewFlag(true);
        setPointsBreakup(points_data);
        setMyScoreBreakup(my_score);
        data.k_id = kId;
        let waf = data.war_end_time;
        const warStartTime = new Date(waf);
        localStorage.setItem("wet", warStartTime);

        setwarStartTime(warStartTime);
        setWarData(data);
        let userType = localStorage.getItem("user_type");
        setMyOppText(data.opp_kd_name);
        if (userType === 'rm' || userType === 'admins') {
            setMyKdText(data.my_kd_name);
            setExtra(<div className="row mb-3" >
                <div className="w-100 profile-flt-l">
                </div>
            </div>);
            setLastLink(
                <div className="row mb-3">
                    <div className="profile-war-info-my-pts-btn w-100 px-3">
                        <div className="profile-war-header-2 w-100" data-toggle="modal" data-target="#bottom_modal_3">
                            <Link to={{
                                pathname: "/war-score-details",
                                state: [data, war_id]
                            }} className="w-100 profile-flt-l">

                                <div style={{ color: "white" }} >Distributor Details</div>
                            </Link>
                        </div>
                    </div>
                </div>
            );
        } else {
            setLastLink(
                <div className="row mb-3">
                    <div className="profile-war-info-my-pts-btn w-100 px-3">
                        <div className="profile-war-header-2 w-100" data-toggle="modal" data-target="#bottom_modal_3">
                            <div className="w-100 profile-flt-l">My Points</div>
                        </div>
                    </div>
                </div>
            );
            setMyKdText("Your Region");
        }
        setMyScore(<div className="profile-war-data-bottom w-100 profile-flt-l center">
            <div className="ms-button-2" data-toggle="modal" data-target="#bottom_modal_2" >Region Details</div>
        </div>);

        const myB = [];
        const kdB = [];
        // data.my_pts = data.my_pts.sort((a, b) => b - a);
        const myServicesAndPoints = data.all_services.reduce((acc, service, index) => {
            acc[service] = data.my_pts[index];
            return acc;
        }, {});
        let sortedMyServicesAndPoints = Object.fromEntries(
            Object.entries(myServicesAndPoints).sort(([, value1], [, value2]) => value2 - value1) // desc order
        );
        Object.keys(sortedMyServicesAndPoints).forEach(function (serviceName) {
            let serviceKey = data.all_services.indexOf(serviceName);
            let imgName = GetServiceNameImagePath(data.all_services[serviceKey])
            let img = require("./../images/" + imgName).default;
            const excludeServices = ["All Rounder"];
            if (!excludeServices.includes(data.all_services[serviceKey])) {
            // if (data.all_services[serviceKey] !== "All Rounder") {
                if (serviceName === 'Utility Bill Payment') {
                    serviceName = 'Bill Payment'
                } else if (serviceName === 'Daily Invest') {
                    serviceName = 'Daily Reserve'
                }
                if(serviceName === 'Saarthi Bonus' && !data.my_pts[serviceKey]>0){
                    return;
                }
                myB.push(
                    <div className="servicebox1dist">
                        <div className="servicebox-innerdist">
                            <div className="servicename mt-1">
                                <img src={img} className="img-fluid img-service" alt="irctc" />
                                <span className="s1">{serviceName}</span>
                            </div>
                            <div className="servicepoints d-flex align-items-center mt-1">
                                <img src="../images/BOR/points-coins.png" className="img-fluid img-service-point"
                                    alt="point" />
                                <span className="sp1">{data.my_pts[serviceKey]}</span>
                            </div>
                        </div>
                    </div>
                );

            }
        });
        kdB.push(getRegionDetails(data));
        kdB.push(getWeaponDetails(data));
        setMyBreakup(myB);
        setKdBreakup(kdB);

        localStorage.setItem("ws", 0);
        if (String(data.war_status) === '1') {
            localStorage.setItem("ws", 1);
        }
    }
    const [isHammer, setIsHammer] = useState(false);
    const [isOpponent, setIsOpponent] = useState(false);
    const hammerOpenModal = (ishammerflag, isOpponent) => {
        setIsHammer(ishammerflag);
        setIsOpponent(isOpponent);
    };

    const timeLeftToWar = () => {
        // console.log("here3");
        let wet = localStorage.getItem("wet");
        const difference = +new Date(wet) - +new Date();
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                // days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60))),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        } else {
            return { 'no': 1 };
        }
        // console.log(timeLeft);
        return timeLeft;
    };
    const [timeLeft, setTimeLeft] = useState(timeLeftToWar());
    useEffect(() => {
        GetWarData();
        const interval = setInterval(() => {
            let timeLt = timeLeftToWar();
            // console.log(timeLt);
            setTimeLeft(timeLt);
        }, 1000);
        return () => { clearInterval(interval) };
    }, []);

    useEffect(() => {
        const int = setInterval(() => {
            GetWarDataSecond()
            // }, 30 * 1000);
        }, 60 * 3 * 1000);
        return () => { clearInterval(int) };
    }, []);
    const imageAnimation = (warData, keyName, setTimeoutLimit) => {
        let bgAnimationTimeLimit = setTimeoutLimit + ((keyName == "opp_kd_top" || keyName == "my_kd_top") ? 1000 : 3000);
        let bgAnimationTimeResetLimit = bgAnimationTimeLimit + 1500;
        let bgStyle = {
            backgroundImage: `url(${pointsBGImageGif})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100%",
        }
        let bgStyleImage = {
            backgroundImage: `url(${pointsBGImage})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100%"
        }
        if (warData && warData[keyName]) {
            warData[keyName].forEach((value, index) => {
                if (value.show_ani) {
                    setTimeout(() => {
                        switch (keyName) {
                            case "opp_kd_ip":
                                setOppIP(() => ({ [index]: "../images/BOR/impact-front-view-newgif.gif" }));
                                break;
                            case "opp_kd_top":
                                setOppTop(() => ({ [index]: "../images/BOR/top-distributors-front-viewnewgif.gif" }));
                                break;
                            case "my_kd_ip":
                                setMyIP(() => ({ [index]: "../images/BOR/Impact-back-viewnewgif.gif" }));
                                break;
                            case "my_kd_top":
                                setMyTop(() => ({ [index]: "../images/BOR/Top-Distributors-back-viewnewgif.gif" }));
                                break;
                        }
                    }, setTimeoutLimit);
                    setTimeout(() => {
                        if (keyName == "opp_kd_ip" || keyName == "opp_kd_top") {
                            setOppPointsBGStyle(bgStyle);
                            setMyPointsBGStyle(bgStyleImage);
                            setShowSpan(true);
                            setShowMySpan(false)

                            setshowOppPoints(value.points_added);
                            setshowMyPoints("");

                            setshowMyNumberOp(true);
                            setshowMyNumber(false);

                        } else if (keyName == "my_kd_ip" || keyName == "my_kd_top") {
                            setMyPointsBGStyle(bgStyle);
                            setOppPointsBGStyle(bgStyleImage);
                            setShowSpan(false);
                            setShowMySpan(true);

                            setshowOppPoints("");
                            setshowMyPoints(value.points_added);

                            setshowMyNumber(true);
                            setshowMyNumberOp(false);
                        }
                        // console.log('bgAnimationTimeLimit', bgAnimationTimeLimit)
                    }, bgAnimationTimeLimit);
                    setTimeout(() => {
                        setMyPointsBGStyle(bgStyleImage);
                        setOppPointsBGStyle(bgStyleImage);
                        setShowMySpan(false);
                        setShowSpan(false);

                        setshowOppPoints("");
                        setshowMyPoints("");

                        setshowMyNumber(false);
                        setshowMyNumberOp(false);

                        // console.log('bgAnimationTimeResetLimit', bgAnimationTimeResetLimit)
                    }, bgAnimationTimeResetLimit);


                    setTimeoutLimit = bgAnimationTimeResetLimit + 1000;
                    bgAnimationTimeLimit = setTimeoutLimit + ((keyName == "opp_kd_top" || keyName == "my_kd_top") ? 1000 : 3000);
                    bgAnimationTimeResetLimit = bgAnimationTimeLimit + 1500;
                }
                if (index === warData[keyName].length - 1) {
                    setTimeout(() => {
                        // Clear the state
                        setOppIP(() => ({}));
                        setOppTop(() => ({}));
                        setMyIP(() => ({}));
                        setMyTop(() => ({}));

                        setshowMyNumber(false);
                        setshowMyNumberOp(false);
                    }, setTimeoutLimit);
                }
            });

        }
    }
    const topCannonAnimation = () => {
        let bgStyle = {
            backgroundImage: `url(${pointsBGImageGif})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100%"
        }
        let bgStyleImage = {
            backgroundImage: `url(${pointsBGImage})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100%"
        }
        let count = 0;
        let count1 = 0;
        let intervalId = setInterval(() => {
            setCannonTopBigImage(cannonBigGif);
            setCannonTopSmallImage(cannonSmallGif);
            if (count === 1) {
                clearInterval(intervalId);
                setCannonTopBigImage(cannonBigImage);
                setCannonTopSmallImage(cannonSmallImage);
                setOppPointsBGStyle(bgStyle);
                let intervalId1 = setInterval(() => {
                    if (count1 === 1) {
                        clearInterval(intervalId1);
                        setOppPointsBGStyle(bgStyleImage);
                    }
                    count1 += 1;
                }, 1000);
            }
            count += 1;
        }, 1500);
    }
    const BottomCannonAnimation = () => {
        let bgStyle = {
            backgroundImage: `url(${pointsBGImageGif})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100%"
        }
        let bgStyleImage = {
            backgroundImage: `url(${pointsBGImage})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100%"
        }
        let countb = 0;
        let countb1 = 0;
        let intervalIdB = setInterval(() => {
            setCannonBottomBigImage(cannonBigGif);
            setCannonBottomSmallImage(cannonSmallGif);
            if (countb === 1) {
                clearInterval(intervalIdB);
                setCannonBottomBigImage(cannonBigImage);
                setCannonBottomSmallImage(cannonSmallImage);
                setMyPointsBGStyle(bgStyle);
                let intervalIdB1 = setInterval(() => {
                    if (countb1 === 1) {
                        clearInterval(intervalIdB1);
                        setMyPointsBGStyle(bgStyleImage);
                        setCanonViewFlag(false);
                    }
                    countb1 += 1;
                }, 1000);
            }
            countb += 1;
        }, 1500);
    }
    useEffect(() => {
        let setTimeoutLimit = 3000;
        console.log("isCanonView", isCanonView)
        if (isCanonView === false && armyViewFlag === true) {
            console.log("isCanonView 1", isCanonView)
            var oppKdIpAniCnt = 0;
            var oppKdTopAniCnt = 0;
            var myKdIpAniCnt = 0;
            warData["opp_kd_ip"].forEach((value, index) => {
                if (value.show_ani) {
                    oppKdIpAniCnt++;
                }
            });
            warData["opp_kd_top"].forEach((value, index) => {
                if (value.show_ani) {
                    oppKdTopAniCnt++;
                }
            });
            warData["my_kd_ip"].forEach((value, index) => {
                if (value.show_ani) {
                    myKdIpAniCnt++;
                }
            });
            var myKdTopAniCnt = 3;
            imageAnimation(warData, "opp_kd_ip", setTimeoutLimit);
            setTimeoutLimit = setTimeoutLimit + (3000 + 4500) * oppKdIpAniCnt;
            imageAnimation(warData, "opp_kd_top", setTimeoutLimit);
            setTimeoutLimit = setTimeoutLimit + (3000 + 2500) * oppKdTopAniCnt;
            imageAnimation(warData, "my_kd_ip", setTimeoutLimit);
            setTimeoutLimit = setTimeoutLimit + (3000 + 4500) * myKdIpAniCnt;
            imageAnimation(warData, "my_kd_top", setTimeoutLimit);
            let hideDivTemp = { "display": "none" };
            if (userType === 'rm' || userType === 'admins') {
                hideDivTemp = (warData.show_brahmastra_ani_rm) ? { "display": "block" } : { "display": "none" };
                setHideDiv(hideDivTemp)
            } else {
                hideDivTemp = (warData.show_brahmastra_ani) ? { "display": "block" } : { "display": "none" };
                setHideDiv(hideDivTemp);
            }
            setArmyViewFlag(false);
        } else {
            if (canonViewFlag === true) {
                setTimeout(() => topCannonAnimation(), 2000);
                setTimeout(() => BottomCannonAnimation(), 6000);
            }
        }
    }, [warData, userType, isCanonView]); // Trigger when `data` changes
    let playerModalPopup = "distributor-player-modal";
    if (userType === 'rm' || userType === 'admins') {
        playerModalPopup = "region-player-modal";
    }

    // Function to close the modal

    //Tooltip
    const [isTooltipVisible, setIsTooltipVisible] = useState(false);
    const toggleTextVisibility = () => {
        setIsTooltipVisible((prev) => !prev); // Toggle the visibility
    };


    const isVisible = warData.show_brahmastra_ani || warData.show_brahmastra_ani_rm;
    return (
        <>
            <Helmet
                link={[{
                    rel: "stylesheet",
                    href: "css/bor.css"
                }, {
                    rel: "stylesheet",
                    href: "css/weapon-fx.css"
                }]}
            />


            <div className="warscore-maincontainer">
                <img
                    src={require("./../images/back.png").default}
                    className="img-fluid backIcon"
                    onClick={() => history.goBack()}
                    style={{
                        width: "1em",
                        cursor: "pointer",
                        position: "absolute",
                        margin: "1em",
                        zIndex: "10"

                    }}
                />
                {(warData.war_status === 3 || warData.war_status === 4) ? (
                    <MatchResult k_id={kdData.k_id} war_id={war_id} myKDName={warData.my_kd_name} myPoints={myBreakup} matchDetails={mwBreakup} war_data={warData} oppKDName={warData.opp_kd_name} myKDTotal={warData.my_total} oppKDTotal={warData.opp_total}></MatchResult>
                ) : (
                    <div className="warscore-innercontainerleft">
                        <Header isOpen={drawersOpen} oppKDName={warData.opp_kd_name} war_data={warData} />
                        {
                            drawersOpen && (
                                <div className="button-container" style={{
                                    display: isVisible ? 'block' : 'none'
                                }}>
                                    <button onClick={handleDrawerClose} id="toggle-drawers-btn">
                                        {allPoints}
                                    </button>
                                </div>
                            )
                        }
                        <div className="carousel-container">
                            {renderArmyWeaponBg("opp")}
                            <div className="carousel top-carousel" ref={topCarouselRef}>

                                <div className="carousel-items">
                                    <div className="army-box text-center">
                                        <img src="../images/BOR/army-frontview.gif" className="army img-fluid" alt="army standing here" />
                                    </div>
                                    <div className="apponent-container"><div className="apponent1">
                                        <div className="opponent1-container">
                                            <div className="row">
                                                <img src={oppIP["0"] || "../images/BOR/front-warriortop-new.png"} alt="Image 1" className="impact-front-view-arrow arrowfront1" />
                                                <img src={oppIP["1"] || "../images/BOR/front-warriortop-new.png"} alt="Image 2" className="impact-front-view-arrow arrowfront2" />
                                                <img src={oppIP["2"] || "../images/BOR/front-warriortop-new.png"} alt="Image 3" className="impact-front-view-arrow absimgtop" />
                                            </div>
                                        </div>
                                    </div>
                                        <div className="apponent1-t2">
                                            <div className="opponent1-container">
                                                <div className="row frontrow1row">
                                                    <img src={oppTop["0"] || "../images/BOR/front-tophammerwarriro-new.png"} alt="Image 1" className="impact-front-view-hammer hamfront1" />
                                                    <img src={oppTop["2"] || "../images/BOR/front-tophammerwarriro-new.png"} alt="Image 2" className="impact-front-view-hammer hamfront2" />
                                                    <img src={oppTop["1"] || "../images/BOR/front-tophammerwarriro-new.png"} alt="Image 3" className="impact-front-view-hammer  hamfront3" />

                                                </div>
                                                <div className="row frontrow2row">
                                                    <img src={oppTop["3"] || "../images/BOR/front-tophammerwarriro-new.png"} alt="Image 2" className="impact-front-view-hammer hamfront4" />
                                                    <img src={oppTop["4"] || "../images/BOR/front-tophammerwarriro-new.png"} alt="Image 3" className="impact-front-view-hammer hamfront5" />

                                                </div>

                                            </div>
                                        </div>


                                    </div>
                                </div>
                                <div className="carousel-items cannonapponentconD">
                                    <div className="apponent-container">
                                        <div className="apponent1canon d-flex oppcanon mt-5">
                                            <div className="frontcanonbig" onClick={toggleTextVisibility}>

                                                <img src={cannonTopBigImage} alt="Canon 1"
                                                    className="canon-front-view C1 img-fluid" />
                                                {isTooltipVisible && <div className="tloo"><span className="tooltipbig">{oppCannonData[13]}</span></div>}

                                            </div>
                                            <div className="frontcanon1" onClick={toggleTextVisibility}>
                                                <img src={cannonTopSmallImage} alt="Canon 2"
                                                    className="canon-front-view C1 img-fluid" />
                                                {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmall">{oppCannonData[0]}</span></div>}
                                            </div>
                                            <div className="frontcanonbig" onClick={toggleTextVisibility}>
                                                <img src={cannonTopBigImage} alt="Canon 2"
                                                    className="canon-front-view C1 img-fluid" />
                                                {isTooltipVisible && <div className="tloo"><span className="tooltipbig">{oppCannonData[12]}</span></div>}
                                            </div>
                                            <div className="frontcanon1" onClick={toggleTextVisibility}>
                                                <img src={cannonTopSmallImage} alt="Canon 1"
                                                    className="canon-front-view C1 img-fluid" />
                                                {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmall">{oppCannonData[1]}</span></div>}
                                            </div>
                                            <div className="frontcanonbig" onClick={toggleTextVisibility}>
                                                <img src={cannonTopBigImage} alt="Canon 2"
                                                    className="canon-front-view C1 img-fluid" />
                                                {isTooltipVisible && <div className="tloo"><span className="tooltipbig">{oppCannonData[11]}</span></div>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="apponent1canon2 d-flex oppcanon mt-5">
                                        <div className="frontcanon1" onClick={toggleTextVisibility}>
                                            <img src={cannonTopSmallImage} alt="Canon 2"
                                                className="canon-front-view C1 C2 img-fluid" />
                                            {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmallmiddle">{oppCannonData[4]}</span></div>}
                                        </div>
                                        <div className="frontcanon1" onClick={toggleTextVisibility}>
                                            <img src={cannonTopSmallImage} alt="Canon 2"
                                                className="canon-front-view C1 C2 img-fluid" />
                                            {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmallmiddle">{oppCannonData[5]}</span></div>}
                                        </div>
                                        <div className="frontcanon1" onClick={toggleTextVisibility}>
                                            <img src={cannonTopSmallImage} alt="Canon 1"
                                                className="canon-front-view C1 C2 img-fluid" />
                                            {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmallmiddle">{oppCannonData[6]}</span></div>}
                                        </div>
                                        <div className="frontcanon1" onClick={toggleTextVisibility}>
                                            <img src={cannonTopSmallImage} alt="Canon 2"
                                                className="canon-front-view C1 C2 img-fluid" />
                                            {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmallmiddle">{oppCannonData[7]}</span></div>}
                                        </div>
                                    </div>
                                    <div className="apponent1canon3 d-flex oppcanon mt-5">
                                        <div className="frontcanonbig" onClick={toggleTextVisibility}>
                                            <img src={cannonTopSmallImage} alt="Canon 1"
                                                className="canon-front-view C1 img-fluid" />
                                            {isTooltipVisible && <div className="tloo"><span className="tooltipbig">{oppCannonData[10]}</span></div>}

                                        </div>
                                        <div className="frontcanon1" onClick={toggleTextVisibility}>
                                            <img src={cannonTopSmallImage} alt="Canon 2"
                                                className="canon-front-view C1 img-fluid" />
                                            {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmall">{oppCannonData[2]}</span></div>}
                                        </div>
                                        <div className="frontcanonbig" onClick={toggleTextVisibility}>
                                            <img src={cannonTopSmallImage} alt="Canon 2"
                                                className="canon-front-view C1 img-fluid" />
                                            {isTooltipVisible && <div className="tloo"><span className="tooltipbig">{oppCannonData[9]}</span></div>}
                                        </div>
                                        <div className="frontcanon1" onClick={toggleTextVisibility}>
                                            <img src={cannonTopSmallImage} alt="Canon 1"
                                                className="canon-front-view C1 img-fluid" />
                                            {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmall">{oppCannonData[3]}</span></div>}
                                        </div>
                                        <div className="frontcanonbig" onClick={toggleTextVisibility}>
                                            <img src={cannonTopSmallImage} alt="Canon 2"
                                                className="canon-front-view C1 img-fluid" />
                                            {isTooltipVisible && <div className="tloo"><span className="tooltipbig">{oppCannonData[8]}</span></div>}
                                        </div>
                                    </div>


                                </div>
                            </div>

                        </div>

                        {showBackdrop && (
                            <div
                                style={{
                                    position: 'fixed',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                    zIndex: 100,
                                }}
                            // onClick={() => {
                            //     setShowBackdrop(false);
                            // }}
                            ></div>
                        )}

                        <div ref={divRef} className="gradient-mainbox">
                            <div className="gradient-border pi1">
                                <div className="content" style={oppPointsBGStyle}>
                                    <img src="../images/BOR/points-coins.png" alt="PI" />
                                    <span className={showMyNumberOp === true ? "text-rolling" : ""}>{warData.opp_total.toLocaleString('en-In', { maximumFractionDigits: 0 })}</span>
                                    {showSpan && (<span className="text">+{showOppPoints}</span>)}

                                </div>
                            </div>
                            <div className="gradient-border pi2" onClick={handlePointsDrawerClick}>
                                <div className="content" style={myPointsBGStyle}>
                                    <img src="../images/BOR/points-coins.png" alt="PI" />
                                    <span className={showMyNumber === true ? "text-rolling" : ""}>{warData.my_total.toLocaleString('en-In', { maximumFractionDigits: 0 })}</span>
                                    {showMySpan && (<span className="text">+{showMyPoints}</span>)}
                                </div>
                            </div>
                        </div>

                        <div className="carousel-container-bottom">
                            {renderArmyWeaponBg("my")}
                            <div className="carousel bottom-carousel" ref={bottomCarouselRef}>
                                <div className="carousel-items bottomcaruselitem1">

                                    <div className="apponent-container warrior-box">
                                        <div className="apponent1-t1">
                                            <div className="opponent1-container">
                                                <div className="row">
                                                    <img src={myIP["0"] || "../images/BOR/back-warriro-arrownew.png"} alt="Image 1" className="impact-back-view-arrow backarrow1" onClick={() => hammerOpenModal(false, false)} data-toggle="modal" data-target={"." + playerModalPopup} zindex="999" />
                                                    <img src={myIP["1"] || "../images/BOR/back-warriro-arrownew.png"} alt="Image 2" className="impact-back-view-arrow backarrow2" onClick={() => hammerOpenModal(false, false)} data-toggle="modal" data-target={"." + playerModalPopup} />
                                                </div>
                                                <div className="row backview2">
                                                    <img src={myIP["2"] || "../images/BOR/back-warriro-arrownew.png"} alt="Image 2" className="impact-back-view-arrow backarrow3" onClick={() => hammerOpenModal(false, false)} data-toggle="modal" data-target={"." + playerModalPopup} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="apponent1-t2">
                                            <div className="opponent1-container">
                                                <div className="row backviewrow1">
                                                    <img src={myTop["0"] || "../images/BOR/back-bottomhammerwarrior-new.png"} alt="Image 1" className="impact-back-view-hammer backhammer1" onClick={() => hammerOpenModal(true, false)} data-toggle="modal" data-target={"." + playerModalPopup} />
                                                    <img src={myTop["2"] || "../images/BOR/back-bottomhammerwarrior-new.png"} alt="Image 2" className="impact-back-view-hammer backhammer2" onClick={() => hammerOpenModal(true, false)} data-toggle="modal" data-target={"." + playerModalPopup} />
                                                    <img src={myTop["1"] || "../images/BOR/back-bottomhammerwarrior-new.png"} alt="Image 3" className="impact-back-view-hammer backhammer3" onClick={() => hammerOpenModal(true, false)} data-toggle="modal" data-target={"." + playerModalPopup} />
                                                </div>
                                                <div className="row backview2">
                                                    <img src={myTop["3"] || "../images/BOR/back-bottomhammerwarrior-new.png"} alt="Image 2" className="impact-back-view-hammer backhammer4" onClick={() => hammerOpenModal(true, false)} data-toggle="modal" data-target={"." + playerModalPopup} />
                                                    <img src={myTop["4"] || "../images/BOR/back-bottomhammerwarrior-new.png"} alt="Image 3" className="impact-back-view-hammer backhammer5" onClick={() => hammerOpenModal(true, false)} data-toggle="modal" data-target={"." + playerModalPopup} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="army-box-bottom text-center">
                                        <img src="../images/BOR/army-backview.gif" className="army img-fluid" alt="army standing here" data-toggle="modal" data-target="#my-army-modal-lg" />
                                    </div>
                                </div>

                                <div className="carousel-items cannonitemcontainer">

                                    <div className="apponent-container">
                                        <div className="apponent1canonbottom d-flex mt-5">
                                            <div className="frontcanonbig" onClick={toggleTextVisibility}>
                                                <img src={cannonBottomSmallImage} alt="Canon 1"
                                                    className="canon-front-view C1 img-fluid" />
                                                {isTooltipVisible && <div className="tloo"><span className="tooltipbigbottom">{myCannonData[10]}</span></div>}

                                            </div>
                                            <div className="frontcanon1" onClick={toggleTextVisibility}>
                                                <img src={cannonBottomSmallImage} alt="Canon 2"
                                                    className="canon-front-view C1 img-fluid" />
                                                {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmallbottom">{myCannonData[0]}</span></div>}
                                            </div>
                                            <div className="frontcanonbig" onClick={toggleTextVisibility}>
                                                <img src={cannonBottomSmallImage} alt="Canon 2"
                                                    className="canon-front-view C1 img-fluid" />
                                                {isTooltipVisible && <div className="tloo"><span className="tooltipbigbottom">{myCannonData[9]}</span></div>}
                                            </div>
                                            <div className="frontcanon1" onClick={toggleTextVisibility}>
                                                <img src={cannonBottomSmallImage} alt="Canon 1"
                                                    className="canon-front-view C1 img-fluid" />
                                                {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmallbottom">{myCannonData[1]}</span></div>}
                                            </div>
                                            <div className="frontcanonbig" onClick={toggleTextVisibility}>
                                                <img src={cannonBottomSmallImage} alt="Canon 2"
                                                    className="canon-front-view C1 img-fluid" />
                                                {isTooltipVisible && <div className="tloo"><span className="tooltipbigbottom">{myCannonData[8]}</span></div>}
                                            </div>
                                        </div>
                                        {/* <div className="apponent1-t2 oppcanon">
                                        <div className="frontcanon1">
                                        <img src={cannonBottomSmallImage} alt="Canon 1"
                                            className="canon-front-view img-fluid" />
                                            </div>
                                            <div className="frontcanonbig">
                                        <img src={cannonBottomBigImage} alt="Canon 2"
                                            className="canon-front-view img-fluid" />
                                            </div>
                                    </div> */}
                                    </div>
                                    <div className="apponent1canon2bottom d-flex mt-5">
                                        <div className="frontcanon1" onClick={toggleTextVisibility}>
                                            <img src={cannonBottomSmallImage} alt="Canon 2"
                                                className="canon-front-view C1 C2 img-fluid" />
                                            {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmallbottommiddle">{myCannonData[4]}</span></div>}
                                        </div>
                                        <div className="frontcanon1" onClick={toggleTextVisibility}>
                                            <img src={cannonBottomSmallImage} alt="Canon 2"
                                                className="canon-front-view C1 C2 img-fluid" />
                                            {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmallbottommiddle">{myCannonData[5]}</span></div>}
                                        </div>
                                        <div className="frontcanon1" onClick={toggleTextVisibility}>
                                            <img src={cannonBottomSmallImage} alt="Canon 1"
                                                className="canon-front-view C1 C2 img-fluid" />
                                            {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmallbottommiddle">{myCannonData[6]}</span></div>}
                                        </div>
                                        <div className="frontcanon1" onClick={toggleTextVisibility}>
                                            <img src={cannonBottomSmallImage} alt="Canon 2"
                                                className="canon-front-view C1 C2 img-fluid" />
                                            {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmallbottommiddle">{myCannonData[7]}</span></div>}
                                        </div>
                                    </div>
                                    <div className="apponent1canon3bottom d-flex mt-5">
                                        <div className="frontcanonbig" onClick={toggleTextVisibility}>
                                            <img src={cannonBottomBigImage} alt="Canon 1"
                                                className="canon-front-view C1 img-fluid" />
                                            {isTooltipVisible && <div className="tloo"><span className="tooltipbigbottom">{myCannonData[13]}</span></div>}

                                        </div>
                                        <div className="frontcanon1" onClick={toggleTextVisibility}>
                                            <img src={cannonBottomSmallImage} alt="Canon 2"
                                                className="canon-front-view C1 img-fluid" />
                                            {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmallbottom">{myCannonData[2]}</span></div>}
                                        </div>
                                        <div className="frontcanonbig" onClick={toggleTextVisibility}>
                                            <img src={cannonBottomBigImage} alt="Canon 2"
                                                className="canon-front-view C1 img-fluid" />
                                            {isTooltipVisible && <div className="tloo"><span className="tooltipbigbottom">{myCannonData[12]}</span></div>}
                                        </div>
                                        <div className="frontcanon1" onClick={toggleTextVisibility}>
                                            <img src={cannonBottomSmallImage} alt="Canon 1"
                                                className="canon-front-view C1 img-fluid" />
                                            {isTooltipVisible && <div className="tloosmall"><span className="tooltipsmallbottom">{myCannonData[3]}</span></div>}
                                        </div>
                                        <div className="frontcanonbig" onClick={toggleTextVisibility}>
                                            <img src={cannonBottomBigImage} alt="Canon 2"
                                                className="canon-front-view C1 img-fluid" />
                                            {isTooltipVisible && <div className="tloo"><span className="tooltipbigbottom">{myCannonData[11]}</span></div>}
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                        {renderUpcomingBoost()}

                        <Playersmodal data={warData} myKDName={warData.my_kd_name} />
                        <ArmyModal myNormalDistributorData={myNormalDistributor} oppNormalDistributorData={oppNormalDistributor} />
                        <DistributorProfileModal war_data={warData} isHammer={isHammer} isOpp={isOpponent} />
                        <Topdistributor war_data={warData} />
                        {/* <DistributorProfileModal /> */}

                        <div id="bottomDrawerRegion" className={`bottom-drawer-region ${isPointsDrawerOpen ? 'show' : ''}`} onClick={handlePointsDrawerClose}>
                            <div className="regionDetails">
                                <p>Region's Details
                                    <span className="close-btn1" onClick={handlePointsDrawerClose}><i class="fa fa-times" aria-hidden="true"></i></span>
                                </p>
                            </div>
                            {kdBreakup}
                        </div>
                        <Footer isOpen={drawersOpen} k_id={kdData.k_id} war_id={war_id} myKDName={warData.my_kd_name} myPoints={myBreakup} regionDetails={kdBreakup} war_data={warData} />
                    </div>
                )}


                <div className="warscore-innercontainerright">
                </div>
            </div>
        </>
    );


}

export default Bor;